<template>
	<q-btn-dropdown split
					color="primary"
					:label="$t('button.logSearchSorting.' + logSearchParams.orderBy[0])"
					:icon="sortingIcon"
					@click="$emit('updatedSortingDirection', disableSorting)"
					:disable="disableSorting"
					no-caps
	>
		<q-list>
			<q-item v-for="(label, option) in options" :key="option" clickable v-close-popup @click="$emit('updatedSorting', option, disableSorting)">
				<q-item-section>
					<q-item-label>{{ $t(label) }}</q-item-label>
				</q-item-section>
			</q-item>
		</q-list>
	</q-btn-dropdown>
</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		name: "SortingSelect",
		props: ['options', 'disable'],
		computed: {
			...mapGetters(['logSearchParams', 'logSearchResults', 'loadingLogs']),
			sortingIcon() {
				return this.logSearchParams.orderDirection[0] ? 'arrow_downward' : 'arrow_upward';
			},
			disableSorting() {
				return !this.logSearchResults.length && !this.loadingLogs || this.disable;
			}
		},
		watch: {
			options(newOptions, oldOptions) {
				if(!newOptions.hasOwnProperty(this.logSearchParams.orderBy[0])) {
					this.$emit('updatedSorting', parseInt(Object.keys(newOptions)[0]), this.disableSorting);
				}
			}
		}
	}
</script>

<style scoped>

</style>